import React, {Component} from "react";
import Illus from "../../../illustration/Sneezing-rafiki.svg";
import MoneyBag from "../../../icons/money-bag.png";
import Man from "../../../icons/man.png";
import Sec from "../../../icons/security.png";
import AnimateVid from "../../../images/Market launch.mp4";

class AboutUs extends Component{

    constructor(props){
        super(props);
        this.state = {
            about : "",
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <div>
                    <h1>About Us</h1>
                </div>
                <div className="about-section">
                    <video loop muted autoPlay >
                        <source src={AnimateVid} />
                    </video>
                    <div className="about-content small-txt">
                        <span>As the first multi-chain Incubator and Launchpad, we create a single, safe destination for both presale investors and prelaunch projects.

                            <br /> <br />

                        Investors benefit from exclusive access to safe, innovative projects and rewarding investments on every blockchain.

                        Developers benefit from our exclusive partnerships with leading blockchain companies, providing increased exposure, complimentary audits, better liquidity, and a dedicated community ready to back them.
                        </span>
                    </div>
                </div>
                <div className="flex-about-widget">
                    <div className="flex-about-card">
                        <img src={MoneyBag} />
                        <h4>Header Text</h4>
                        <p className="small-txt sec-txt">
                            Developers benefit from our exclusive partnerships with leading blockchain companies, providing increased exposure, complimentary audits, better liquidity, and a dedicated community ready to back them.
                        </p>
                    </div>
                    <div className="flex-about-card">
                        <img src={Sec} />
                        <h4>Header Text</h4>
                        <p className="small-txt sec-txt">
                            Developers benefit from our exclusive partnerships with leading blockchain companies, providing increased exposure, complimentary audits, better liquidity, and a dedicated community ready to back them.
                        </p>
                    </div>
                    <div className="flex-about-card">
                        <img src={Man} />
                        <h4>Header Text</h4>
                        <p className="small-txt sec-txt">
                            Developers benefit from our exclusive partnerships with leading blockchain companies, providing increased exposure, complimentary audits, better liquidity, and a dedicated community ready to back them.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutUs;